/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { MemberStatusDto } from './memberStatusDto.schema';

export const IReadOnlyListOfMemberStatusDto = zod.array(zod.lazy(() => MemberStatusDto));

export type IReadOnlyListOfMemberStatusDto = zod.input<typeof IReadOnlyListOfMemberStatusDto>;
export type IReadOnlyListOfMemberStatusDtoOutput = zod.output<typeof IReadOnlyListOfMemberStatusDto>;
